import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '@/core/services/open-api/user.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false,
})
export class SettingsComponent implements OnInit, OnDestroy {
    isAdmin: boolean = false;
    initialized = false;
    private subscriptions = new Subscription();

    constructor(public readonly userService: UserService) {}

    ngOnInit(): void {
        this.subscriptions.add(
            this.userService.currentUser$.subscribe(async (currentUser) => {
                this.isAdmin = currentUser.isAdmin();
                this.initialized = true;
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
